module.exports = __webpack_public_path__ + "static/media/UE_Logo_Stacked_RGB_White@2x.0bf1fbbd.png";